import { translate, } from 'react-i18next';
export var withTranslation = function (component) { return translate()(component); };
//# sourceMappingURL=with-translation.js.map